import React, {Fragment} from 'react'
import PropTypes from 'prop-types'

import Headline from '#components/a/Headline'
import StyledUnorderedList from '#components/a/StyledUnorderedList'
import StyledText from '#components/a/StyledText'
import QuestionSet from '#components/m/Ausbildungsplan/QuestionSet'

class AusbildungsplanContent extends React.Component {
  wrapStaticContent = content => (
    <div className="ausbildungsplan__content-wrapper ausbildungsplan__content-wrapper--wide">
      <div className="ausbildungsplan__content">{content}</div>
    </div>
  )

  render() {
    const {element, azubiId} = this.props
    switch (element.type) {
      case 'headline':
        return this.wrapStaticContent(<Headline text={element.text} importance={3} modifier="section" />)
      case 'subheadline':
        return this.wrapStaticContent(<Headline text={element.text} importance={4} modifier="category" />)
      case 'paragraph':
        return this.wrapStaticContent(<StyledText text={element.text} />)
      case 'unorderedlist':
        return this.wrapStaticContent(
          <>
            <StyledText text={element.text} />
            <StyledUnorderedList items={element.content.map(c => c.text)} />
          </>,
        )
      case 'image':
        return this.wrapStaticContent(<img alt={element.text} src={`/api/files/staticfiles/${element.url}`} />)
      case 'questionset':
        return <QuestionSet azubiId={azubiId} questions={element.content} title={element.text} chapterId={element.id} />
      default:
        return !element.content
          ? null
          : element.content.map((child, index) => (
              <AusbildungsplanContent key={index.toString()} azubiId={azubiId} element={child} />
            ))
    }
  }
}

AusbildungsplanContent.propTypes = {
  element: PropTypes.object,
  azubiId: PropTypes.number.isRequired,
}

export default AusbildungsplanContent
